import type { ApiCarrierListItem, InviteCarrierData } from "api-client";
import { OPERATOR_SCOPED_ID } from "../constants/operator.constants";

export function mapInviteCarrierDataToListItem(
  data: InviteCarrierData,
  carrierId: number,
  customerName?: string,
): ApiCarrierListItem {
  const risk = data.riskScore?.trim() ?? "";
  const resolvedCustomerName = customerName?.trim() ?? "";
  const authorityLabel = data.dotStatus ? "Active" : "Inactive";
  const nowIso = new Date().toISOString();
  return {
    carrierId,
    carrierName: data.carrierName,
    operatorId: OPERATOR_SCOPED_ID,
    operatorName: "",
    customerIds: data.customerId != null && data.customerId > 0 ? [data.customerId] : [],
    customerNames: resolvedCustomerName ? [resolvedCustomerName] : [],
    dotNumber: data.dotNumber?.trim() ?? "",
    stateId: data.stateProvinceId?.trim() ?? "",
    email: data.email,
    scac: data.scacCode?.trim() ?? "",
    mcNumber: "",
    address: data.businessAddress?.trim() ?? "",
    status: "InviteSent",
    dotStatus: authorityLabel,
    riskScore: risk,
    riskLevel: risk,
    createdDate: nowIso,
    safetyScore: data.safetyScore,
    primaryContactName: data.contactName,
    phone: data.phone?.trim() ?? "",
    authority: authorityLabel,
    lastEntryDate: nowIso,
  };
}
